export const selectUserLogs = (state) => state.userLogs;
export const selectUserLogsTotal = (state) => state.userLogsTotal;
export const selectPlayerLogs = (state) => state.playerLogs;
export const selectPlayerLogsTotal = (state) => state.playerLogsTotal;
export const selectUserManagementLogs = (state) => state.userManagementLogs;
export const selectUserManagementLogsTotal = (state) => state.userManagementLogsTotal;
